<template>
  <div class="bg-slate-50 rounded-2xl p-4 h-full flex flex-col">
    <h1 class="text-base sm:text-xl leading-snug font-bold text-slate-950 mb-2">
      {{
        $i18n.locale != "cyr"
          ? data[`organization_${$i18n.locale}`]
            ? data[`organization_${$i18n.locale}`]
            : data.organization
          : data.organization
      }}
    </h1>
    <div class="flex-1"></div>
    <div
      class="flex flex-wrap 2xl:flex-nowrap gap-2 items-center justify-center 2xl:justify-between"
    >
      <div>
        <div style="width: 220px">
          <div
            class="text-sm leading-snug text-slate-950 flex items-center justify-between"
          >
            <p>{{ $t("existing_buildings") }}</p>
            <p class="font-bold">
              {{ data.existing_buildings | formatNumber }} {{ $t("ta") }}
            </p>
          </div>
          <div
            class="text-sm leading-snug text-slate-950 flex items-center justify-between"
          >
            <p>{{ $t("new_buildings") }}</p>
            <p class="font-bold">
              {{ data.new_buildings | formatNumber }} {{ $t("ta") }}
            </p>
          </div>
          <div
            class="text-sm leading-snug text-slate-950 flex items-center justify-between"
          >
            <p>{{ $t("all_buildings") }}</p>
            <p class="font-bold">
              {{ data.all_buildings | formatNumber }} {{ $t("ta") }}
            </p>
          </div>
          <div
            class="text-sm leading-snug text-slate-950 flex items-center justify-between"
          >
            <p>{{ $t("users") }}</p>
            <p class="font-bold">
              {{ data.users | formatNumber }} {{ $t("ta") }}
            </p>
          </div>
        </div>
      </div>
      <div>
        <PieChart
          :series="series"
          :labels="labels"
          :labelShow="false"
          :width="300"
          mini
          valueFontSize="24px"
          totalFontSize="12px"
        />
      </div>
    </div>
    <div class="flex flex-col 2xl:flex-row gap-2 mt-2">
      <div
        class="bg-white pl-2 p-1 rounded-l-lg rounded-r-2xl flex items-center w-full"
      >
        <p class="text-xs leading-snug text-slate-950 sm:w-48">
          {{ $t("an_incomplete_building") }}:
        </p>
        <div class="flex-1"></div>
        <span class="text-lg leading-snug font-bold text-blue-600"
          >{{ data.an_incomplete_building }} {{ $t("ta") }}</span
        >
        <button
          class="ml-2 w-10 h-10 rounded-xl bg-slate-50 flex justify-center items-center"
          @click="
            $router.push(
              `/statistica/buildings/uncomplate?id=${data.id}&name=${data.organization}`
            )
          "
        >
          <hDirectionRight01 />
        </button>
      </div>
      <div
        class="bg-white pl-2 p-1 rounded-l-lg rounded-r-2xl flex items-center w-full"
      >
        <p class="text-xs leading-snug text-slate-950 sm:w-44">
          {{ $t("an_incomplete_new_building") }}:
        </p>
        <div class="flex-1"></div>
        <span class="text-lg leading-snug font-bold text-cyan-600"
          >{{ data.an_incomplete_new_building }} {{ $t("ta") }}</span
        >
        <button
          class="ml-2 w-10 h-10 rounded-xl bg-slate-50 flex justify-center items-center"
          @click="
            $router.push(
              `/statistica/buildings/uncomplatenew?id=${data.id}&name=${data.organization}`
            )
          "
        >
          <hDirectionRight01 />
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import hDirectionRight01 from "../Icons/hDirectionRight01.vue";
import PieChart from "@/components/PieChart.vue";
export default {
  components: { hDirectionRight01, PieChart },
  name: "OrgCard",
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    series() {
      return [
        this.data.sustainable_buildings || 0,
        this.data.not_sustainable_buildings || 0,
        this.data.not_sustainable_buildings4 || 0,
      ];
    },
  },
  data() {
    return {
      labels: [
        this.$t("sustainable_buildings"),
        this.$t("not_sustainable_buildings"),
        this.$t("not_sustainable_buildings4"),
      ],
    };
  },
};
</script>

<style lang="scss" scoped></style>
